import { api } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const PassengerAPI = {

    GetPortalAccount: async function (ParentID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/account/' + ParentID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostPortalAccount: async function (postJSON, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/account/',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostChangeEmail: async function (payerId, postJSON, cancel = false){
        const response = await api.request({
            // url: '/school-tour-company/rest/portal/account/' + postJSON.payerId,
            url: '/school-tour-company/rest/portal/account/' + payerId + '/changeEmail',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetPortalPassengers: async function (ParentID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/passengers/' + ParentID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetPassengersTours: async function (PassengerID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/tourlist/' + PassengerID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetTourDetails: async function (bookingID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/tourdetails/' + bookingID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetPaymentHistory: async function (portalpassengerID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/getpayments/' + portalpassengerID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetPassengerPaymentAttempts: async function (payerID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/payerid/' + payerID + '/paymentattempts',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    // PostPassenger: async function (bookingID, passengerData, cancel = false){
    //     const response = await api.request({
    //         url: '/portal/registerpassenger/' + bookingID,
    //         method: 'POST',
    //         data: passengerData,
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
    //     })

    //     return {
    //         data: response.data,
    //         status: response.status,
    //         statusText: response.statusText
    //     }
    // },

    PostRegisterPassengerTour: async function (bookingID, passengerData, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/registerpassenger/' + bookingID,
            method: 'POST',
            data: passengerData,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostSavePayment: async function (postJSON, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/savepayment',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
    
    PostPassengerPassport: async function (passengerID, passportData, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/savepassport/' + passengerID,
            method: 'POST',
            data: passportData,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostPaymentSession: async function (postJSON, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/storepaymentsession',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetPaymentSession: async function (orderId, cancel = false){
        const response = await api.request({
            url: `/school-tour-company/rest/portal/paymentsession/${orderId}/fetch`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
}
const cancelAPIObject = defineCancelApiObject(PassengerAPI)